/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */


// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Box, Modal, TextField } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBank } from "Redux/actions/user";
import { getDashboard } from "Redux/actions/user";
import { updateUserCash } from "Redux/actions/user";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { sm: '100%', md: '80%', lg: '30%' },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};
function ComplexStatisticsCard({ color, title, count, icon,button,action ,buttonColor}) {
  const [open, setOpen] = useState(false);
  const dispatch=useDispatch();
  const {dashboard}=useSelector(state=>state.user);
  const [formData, setFormData] = useState({
    amount:"",
    type:"send",
  });
  const handleType=(type)=>{
    // console.log(type)
    if(type==='edit'){
      setFormData({amount:dashboard.cash,type:type})
    }
    else setFormData({amount:'',type:type})
  }
  const handleClose=()=>{
    setFormData({amount:'',type:'send'})
    setOpen(false)

  }
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEdit=()=>{
    if(action==="bank"){
      dispatch(updateBank(formData));
      dispatch(getDashboard());
      }
    else {
      dispatch(updateUserCash(formData));
      dispatch(getDashboard());
      setFormData({amount:'',type:'send'})
     
    }
    setOpen(false)
  }

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
        <MDBox
          variant="gradient"
          bgColor={color}
          color={color === "light" ? "dark" : "white"}
          coloredShadow={color}
          borderRadius="xl"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          mt={-3}
        >
          <img src={icon}/>
        </MDBox>
        <MDBox textAlign="right" lineHeight={1.25}>
          <MDTypography variant="button" fontWeight="light" color="text">
            {title}
          </MDTypography>
          <MDTypography variant="h4">{count}</MDTypography>
        </MDBox>
      </MDBox>
      {(!button)&&<Divider />}
      <MDBox pb={2} px={2}>
        {button&&<MDButton variant="contained" color={buttonColor}  size="small" sx={{float:"right",marginBottom:"2.5px"}} onClick={()=>setOpen(true)}>
          <MDTypography variant="button" fontWeight="bold" color="white">EDIT</MDTypography>
            
          </MDButton>}
          <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style}>
                      <MDTypography id="modal-modal-title" variant="h6" component="h2">
                        Edit {title}
                      </MDTypography>

                      <select name="type" className="" onChange={(e)=>handleType(e.target.value)}  >
                          <option selected hidden value={formData.type}>{formData.type} </option>
                          <option value="send">Send</option>
                          <option value="received">Received</option>
                          {action==='cash'&&<option value="edit">Edit</option>
}
                        </select>
                      <br />
                      <TextField id="standard-basic" className="input-field" name="amount" value={formData.amount} onChange={handleChange}  label="Amount" variant="standard" required />
                      <br />

                      <MDButton variant="contained" color={buttonColor} onClick={handleEdit}  size="small" sx={{marginTop:"10px"}} >Save</MDButton>

                      

                    </Box>
                  </Modal>
          
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
ComplexStatisticsCard.defaultProps = {
  color: "info",
  percentage: {
    color: "success",
    text: "",
    label: "",
  },
};

// Typechecking props for the ComplexStatisticsCard
ComplexStatisticsCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
  }),
  icon: PropTypes.node.isRequired,
};

export default ComplexStatisticsCard;
